export default {
  name: "CalendarCancelSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M28 6h-3.5V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5V6h-11V3.5C10.5 2.67 9.83 2 9 2s-1.5.67-1.5 1.5V6H4c-1.16 0-2 .84-2 2v20c0 1.16.84 2 2 2h24c1.16 0 2-.84 2-2V8c0-1.16-.84-2-2-2zm-6.69 15.19c.59.59.59 1.54 0 2.12s-1.54.59-2.12 0L16 20.12l-3.19 3.19c-.59.59-1.54.59-2.12 0s-.59-1.54 0-2.12L13.88 18l-3.19-3.19a1.49 1.49 0 0 1 0-2.12 1.49 1.49 0 0 1 2.12 0L16 15.88l3.19-3.19a1.49 1.49 0 0 1 2.12 0c.59.59.59 1.54 0 2.12L18.12 18l3.19 3.19z",
  },
}
